import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/store";
import { checkTokenExpiration } from "../utils/tokenUtils";
import { updateProfilePicture } from "../redux/authSlice";
import { getAdminProfile } from "../services/adminProfileService";

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, accessToken } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    // Initial token check
    if (!checkTokenExpiration()) {
      return;
    }

    // Check token every minute
    const interval = setInterval(() => {
      checkTokenExpiration();
    }, 60000);

    return () => clearInterval(interval);
  }, [accessToken]);

  // Keep avatar in sync with the server (survives refresh and re-login)
  useEffect(() => {
    if (!isAuthenticated || !accessToken) return;

    let cancelled = false;
    (async () => {
      try {
        const profile = await getAdminProfile();
        if (!cancelled && profile.profilePicture) {
          dispatch(updateProfilePicture(profile.profilePicture));
        }
      } catch {
        // Non-blocking — header falls back to default avatar
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, accessToken, dispatch]);

  // Use checkTokenExpiration for route protection
  if (!isAuthenticated || !accessToken || !checkTokenExpiration()) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
